import { createSelector } from '@ngrx/store';
import { getAuthInfoStateSelector } from 'src/app/auth/store/index';
import { getOriginUrl } from 'src/app/auth/store/reducers/info.reducer';

export const getOriginUrlSelector = createSelector(
  getAuthInfoStateSelector,
  getOriginUrl
);
